import { Motivering as MotiveringAlgemeenDlEntry } from "../../.generated/forms/formstypes";
import { UiName, FieldMap } from "../../shared/types";
import { target2field } from "../../shared/utils/target-to-field";

export function mapDlTargetToMotiveringAlgemeenUiField(target: string): UiName | null {
  const map: FieldMap<MotiveringAlgemeenDlEntry> = {};

  return target2field(map, target);
}
